import {Directive} from '@angular/core';
import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

@Directive({selector: '[appAllowedMailDomainsValidator]'})
export class AllowedMailDomainsValidatorDirective {
}

export function onlyAllowedMailDomainsValidator(domainRe: RegExp): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const forbiddenDomain = !domainRe.test(control.value);
    return forbiddenDomain ? {forbiddenDomain: {value: control.value}} : null;
  };
}
